import {applySavedSelections, createExportFieldPrefs} from '@/lib/exportFieldPrefs';
import type {ExportFieldSetting} from '@/lib/exportFieldPrefs';

/**
 * The linked label popup's last field selection per feature type, stored under `linkedLabelFields` on the user's doc.
 * Reuses the export field prefs shape, with one tab per feature type.
 */
const {saveExportFieldSelections, loadExportFieldSelections} = createExportFieldPrefs(
  'linkedLabelFields',
  'linked-label',
);

/** One checkbox per distinct field label, in field order, all checked until a saved selection says otherwise. */
export function buildLinkedLabelFieldOptions(displayFields: {label?: string | null}[]): ExportFieldSetting[] {
  const labels = new Set(displayFields.map((field) => field.label).filter((label): label is string => !!label));
  return [...labels].map((label) => ({label, value: true}));
}

export function selectedLinkedLabelFields(options: ExportFieldSetting[]): string[] {
  return options.filter((option) => option.value === true).map((option) => option.label);
}

export async function loadLinkedLabelFieldOptions(
  featureType: string,
  displayFields: {label?: string | null}[],
): Promise<ExportFieldSetting[]> {
  const options = buildLinkedLabelFieldOptions(displayFields);
  applySavedSelections(new Map([[featureType, options]]), await loadExportFieldSelections());
  return options;
}

/** Never throws. */
export async function saveLinkedLabelFieldOptions(featureType: string, options: ExportFieldSetting[]): Promise<void> {
  await saveExportFieldSelections(new Map([[featureType, options]]));
}
